export enum ClaimsPermissions {
  ChClaims = "ChClaims",
  ChClaimsManagement = "ChClaimsManagement",
  ChClaimsPaymentApproval = "ChClaimsPaymentApproval",
  ChClaimsReport = "ChClaimsReport",
  ChAccessAllUsersClaim = "ChAccessAllUsersClaim",
  ChAccessAllBrancheClaim = "ChAccessAllBrancheClaim",
  ChClaimsManagementSystemReadOnly = "ChClaimsManagementSystemReadOnly",
  ChOnlineClaimsManagement = "ChOnlineClaimsManagement",

  chMedical = "ChMedical",
  chMotor = "ChMotor",
  chGeneral = "ChGeneral",
}
